enum ApplicationType {
  Lite = 'lite',
  Guest = 'guest',
  FullClient = 'fullClient',
  SignUp = 'signUp',
  Identity = 'identity',
  Support = 'support',
  Partner = 'partner',
  InvitedAnonymous = 'invitedAnonymous',
  Translations = 'translates',
}

export const ApplicationTypeDict: {
  [id: string]: ApplicationType;
} = {
  Lite: ApplicationType.Lite,
  Guest: ApplicationType.Guest,
  FullClient: ApplicationType.FullClient,
  SignUp: ApplicationType.SignUp,
  Identity: ApplicationType.Identity,
  Support: ApplicationType.Support,
  Partner: ApplicationType.Partner,
  InvitedAnonymous: ApplicationType.InvitedAnonymous,
  Translations: ApplicationType.Translations,
};

export default ApplicationType;
